import { render } from "./workBrieManage.vue?vue&type=template&id=6036b0ff&scoped=true"
import script from "./workBrieManage.vue?vue&type=script&lang=js"
export * from "./workBrieManage.vue?vue&type=script&lang=js"

import "./workBrieManage.vue?vue&type=style&index=0&id=6036b0ff&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6036b0ff"]])

export default __exports__